import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-date-picker";
import { FormFeedback } from "reactstrap";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "./DatePickerField.css";

const toDateValue = (value) => {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const DatePickerField = ({
  className = "",
  minDate,
  maxDate,
  format = "dd-MM-yyyy",
  disabled,
  ...props
}) => {
  const { setFieldValue, setFieldTouched, submitCount } = useFormikContext();
  const [field] = useField(props);
  const { errors, touched, name } = props;

  const showError = Boolean(errors[name] && (touched[name] || submitCount > 0));

  return (
    <div className={`datepicker-field ${className}`.trim()}>
      <DatePicker
        id={name}
        name={name}
        className="w-100"
        format={format}
        value={toDateValue(field.value)}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        clearIcon={null}
        calendarAriaLabel="Toggle calendar"
        onChange={(val) => {
          setFieldValue(name, val);
          setFieldTouched(name, true, false);
        }}
        onBlur={() => setFieldTouched(name, true, false)}
      />
      {showError && (
        <FormFeedback className="d-block">{errors[name]}</FormFeedback>
      )}
    </div>
  );
};

export default DatePickerField;
